import { get } from '../utils/api'

export const fetchCertData = async (limitCnt) => {
  try {
    const response = await get('/cert/list', {
      limitCnt: limitCnt, 
    });
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  };
};
